export default {
    header: {
        pillLabel: 'Preparation Tips / Advice',
        title: '360 Feedback Review Preparation Tips',
        description:
            'Master the art of providing meaningful feedback that drives professional growth and development.',
    },
    content: {
        cardTitle: 'Before starting your 360 Feedback Review,',
        cardText: 'please take a quick moment to review these helpful tips.',
        calm: {
            title: 'Take a moment to be calm',
            text: 'Responding to a 360 Evaluation isn’t just about checking boxes: it’s about contributing to a colleague’s development. Find a quiet environment to reflect and formulate sincere, nuanced, and helpful responses.',
        },
        examples: {
            title: 'Rely on concrete examples',
            text: 'If you’re stuck on a question, think of one or two recent situations involving this person. This will help you be more precise, fair, and relevant in your feedback.',
        },
        beyondRole: {
            title: 'Observe beyond the official role',
            text: 'Try to see what this person brings beyond their job description: atmosphere, support, mediation, innovation, energy, vision. The 360 Evaluation also aims to highlight invisible contributions.',
        },
        growth: {
            title: 'Think in terms of growth, not judgment',
            text: 'If a question leads you to suggest an area for improvement, frame it as a possibility for growth. Avoid labels and focus on observable behaviors, contexts, or perceived intentions.',
        },
        experience: {
            title: 'Stay focused on your own experience',
            text: 'You don’t need to represent the full team. Focus on your own observations and experiences to keep feedback sincere and useful.',
        },
        balance: {
            title: 'Seek balance: strengths and development areas',
            text: 'A good 360 Evaluation is not just praise or critique. Highlight strengths as well as areas that can be further developed.',
        },
        unsure: {
            title: 'And if you’re unsure…',
            text: 'Ask yourself what you would like to hear if you were in their position. This helps balance honesty with kindness.',
        },
    },
    selfEvaluationHeader: {
        pillLabel: 'Self-Assessment',
        title: 'Your Self-Assessment',
        description:
            'This is the time to step back and reflect on your journey. Your reflections will fuel a rich discussion with your {{managerLabel}} and help you chart the path ahead. Be authentic, your voice matters.',
    },
    selfEvaluationContent: {
        cardTitle: 'Before starting your self-assessment,',
        cardText: 'please take a moment to read these helpful tips.',
        calm: {
            title: 'Take a moment to reflect calmly',
            text: 'A self-assessment is more than filling out fields. It is an opportunity to step back and reflect on your progress, achievements, and learning. Choose a quiet moment to provide thoughtful and balanced responses.',
        },
        examples: {
            title: 'Use concrete examples',
            text: 'When describing your strengths or challenges, think of specific and recent situations. Concrete examples make your reflection clearer and more useful for upcoming discussions.',
        },
        beyondRole: {
            title: 'Look beyond tasks',
            text: 'Consider not only what you do, but how you contribute, collaboration, initiative, autonomy, communication, and overall impact on your team.',
        },
        growth: {
            title: 'Focus on growth, not judgment',
            text: 'A self-assessment is a development tool. Highlight your strengths, while also identifying areas that could support your continued professional growth.',
        },
        experience: {
            title: 'Stay centered on your own experience',
            text: 'Focus on your role, responsibilities, and daily realities. The goal is to share your perspective clearly and authentically.',
        },
        balance: {
            title: 'Seek balance: strengths and growth areas',
            text: 'A strong self-assessment recognizes accomplishments while also acknowledging opportunities for improvement.',
        },
        unsure: {
            title: "If you're unsure…",
            text: 'Ask yourself: What have I learned recently? What am I most proud of? Where could I improve further? These questions can help guide your reflection.',
        },
    },
    cta: {
        cardText: 'Ready to begin?',
        buttonText: 'Start Giving Feedback',
        selfEvaluationButtonText: 'Start my self-assessment',
    },
};
